export default "__VITE_ASSET__e4S9CiSD__"